import { Root } from '@makemydeal/dr-activities-credit-bureau';
import { CREDIT_BUREAU_ROUTE_ROOT } from '../constants';

const CreditBureau = () => {
    return <Root baseRoute={CREDIT_BUREAU_ROUTE_ROOT} />;
};

export default CreditBureau;
